import React from 'react';
import { motion } from 'framer-motion';
import { introHighlights } from '../data/siteContent';

const Introduction = () => {
  return (
    <section className="introduction">
      <div className="container">
        <motion.div
          className="intro-content"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="section-kicker">Patient-first diabetes support</span>
          <h2 className="section-title">Welcome to Uttam Diabetes Care & Research Center</h2>
          <div className="intro-text">
            <p>
              Dr. Santosh Kumar and the care team focus on structured support for diabetes, insulin-related
              care, and kidney wellness. The goal is not only treatment, but also better understanding,
              disciplined follow-up, and confidence for every patient family.
            </p>
            <p className="intro-hindi">
              हिंदी बोलने वाले मरीजों के लिए हम इलाज, जांच, खान-पान, दवा और फॉलो-अप की बातों को सरल
              भाषा में समझाने पर विशेष ध्यान देते हैं, ताकि किसी भी मरीज को जानकारी की कमी महसूस न हो।
            </p>
          </div>

          <div className="intro-highlight-grid">
            {introHighlights.map((item, index) => (
              <motion.div
                key={item}
                className="intro-highlight-card"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.45 }}
              >
                <i className="fas fa-check-circle"></i>
                <p>{item}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Introduction;
